import { t } from '../i18n';
import logoImage from '../assets/logo.png';

const Logo = () => {
  return (
    <div className="relative w-8 h-8 overflow-hidden">
      <img 
        src={logoImage} 
        alt={t("Virtuoz Solutions Logo")}
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default Logo;